import http from '@/http';

export default {

    list() {
        return http.get('/contract-items');
    },

    get(id) {
        return http.get(`/contract-items/${id}`);
    },
};



// WEBPACK FOOTER //
// ./src/api/contractItems.js